/**
 * Shorthand function that formats a date to a string.
 */
const getFormattedTimeStamp = (date) => {
    if (!date)
        return '';
    return new Date(date).toLocaleDateString(undefined, {
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        month: 'short',
        // TODO: remove the year when it matches current year:
        // https://msazure.visualstudio.com/One/_workitems/edit/9905986
        year: 'numeric',
    });
};
// Exports
// -------
export { getFormattedTimeStamp };
